import { useMemo } from 'react';
import { ReturnTypeofSheetSectionsSelector } from '../../../selectors/sheetUiSelector';
// import AreaSelection from './AreaSelection';
import { UseSheetTheme } from '../../../hooks/useSheetTheme';
import { Area, SelectionOperationType } from '../../../types';
import { useAppSelector } from '../../../../core/hooks/storeHooks';
import { UseCellSelection } from '../../../hooks/useCellSelection';
import AreaSelection from './AreaSelection';

interface SelectionsProps
  extends ReturnTypeofSheetSectionsSelector,
    Pick<
      UseSheetTheme,
      | 'isRtl'
      | 'selectionFill'
      | 'extendCircleBorderColor'
      | 'extendSelectionBorderColor'
      | 'isDarkTheme'
    >,
    Pick<UseCellSelection, 'handleSelectionInteraction'> {
  sheetId: string;
  stageWidth: number;
}

const Selections: React.FC<SelectionsProps> = ({
  sheetId,
  selections,
  stageWidth,
  isRtl,
  selectionFill,
  temporarySelection,
  extendCircleBorderColor,
  extendSelectionBorderColor,
  ...props
}) => {
  const activeSheetId = useAppSelector(
    (state) => state.sheetsManager.activeSheetId
  );

  const renderAreaSelection = (
    key: string,
    area: Area,
    zIndex: number,
    currentOp?: SelectionOperationType,
    tempOp?: SelectionOperationType,
    active = false
  ) => (
    <AreaSelection
      key={key}
      {...props}
      area={area}
      sheetId={sheetId}
      isActive={active}
      isRtl={isRtl}
      selectionFill={selectionFill}
      stageWidth={stageWidth}
      selecting={props.selecting && sheetId === activeSheetId}
      extendCircleBorderColor={extendCircleBorderColor}
      extendSelectionBorderColor={extendSelectionBorderColor}
      zIndex={zIndex}
      currentOp={currentOp}
      tempOp={tempOp}
    />
  );

  const areas = useMemo(() => {
    const selectionAreas = selections.map((selection, index) =>
      renderAreaSelection(
        `selection-${index + 1}`,
        selection.area,
        2 + index,
        undefined,
        temporarySelection?.op,
        index === selections.length - 1
      )
    );
    // let TempSelection: JSX.Element | undefined;
    if (temporarySelection) {
      selectionAreas.push(
        renderAreaSelection(
          `temp-Selection-${sheetId}`,
          temporarySelection.area,
          1,
          temporarySelection.op
        )
      );
    }

    return selectionAreas;
  }, [
    // props.cols,
    // props.rows,
    // props.freezedCols,
    // props.freezedRows,
    // props.colHeaderHeight,
    // props.colFilterHeight,
    // props.rowHeaderWidth,
    // props.defaultColWidth,
    // props.defaultRowHeight,
    props.colViewport,
    props.rowViewport,

    props.selecting,
    selections,
    isRtl,
    stageWidth,
    temporarySelection,
    props.isDarkTheme,
    // selectionFill,
    // extendCircleBorderColor,
    // extendSelectionBorderColor,
    props.handleSelectionInteraction,
  ]);

  return <>{areas}</>;
};

export default Selections;
